<template>
  <div class="top-bar-container">
    <wrap-container class="w100">
      <div class="inner-container">
        <div class="logo">
          <img src="@/assets/img/logo.svg" alt="BBVA" />
        </div>
        <div class="modulo">
          <p v-html="modulo" />
        </div>
      </div>
    </wrap-container>
    <progress-bar />
  </div>
</template>

<script>
import Vue from "vue";
import WrapContainer from "@/components/core/Container";
import conf from "@/config/brands/index";

Vue.component("progress-bar", () => import("./ProgressBar"));

export default {
  name: "TopBar",
  components: { WrapContainer },
  computed: {
    modulo() {
      if(process.env.VUE_APP_CAMP === 'ofertaDigital'){
        const origin = this.$store.state.origen;
        if(origin === 'REFEM' || origin === 'REFCL'){
          return 'Referidos emprendedores';
        }
      }
      return conf.modulo;
    },
  }
};
</script>

<style scoped>
div.top-bar-container {
  background: #043263;
  color: white;
  position: fixed;
  width: 100%;
  z-index: 9999;
  padding: 0 17px;
}

div.inner-container {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

div.logo img {
  height: 20px;
}

div.modulo {
  text-align: right;
}

p {
  font-size: 16px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  margin: 0;
}

@media screen and (max-width: 420px) {
  div.logo img {
    height: 13px;
  }
  p {
    font-size: 12px;
  }
}
</style>
